import { CAMPAIGN_BUDGET_URL } from '../../../utils/Endpoints';
import { BaseModel } from '../../../model/shared/BaseModel';
import { requests } from '../../../api/services';
import { IBudget } from '../../statistics/dto/iBudget';

export const BudgetOverviewService = {
    getBudgetOverview: (params?: any): Promise<BaseModel<IBudget>> => requests.get(`${CAMPAIGN_BUDGET_URL}`, params),
    updateTotalInvoiced: (campaignId: number, body: any): Promise<BaseModel<IBudget>> =>
        requests.post(`${CAMPAIGN_BUDGET_URL}/${campaignId}`, body),
};
